import {
  ChartPie, Receipt, ListChecks, ChartBar, ShieldCheck, ClockCounterClockwise,
  Trophy, ChatCircleText, EnvelopeSimple, Database, Scroll, Scales, Gavel, Coins, Columns,
} from '@phosphor-icons/react';

// Simplified nav — focus on Invoices/Collections. Properties, Units, Tenants,
// and Contracts have been retired; their data is embedded on invoice records.
export const COLLECTIONS_NAV = [
  { to: '/invoices',    label: 'الفواتير',           icon: Receipt },
  { to: '/dashboard',   label: 'لوحة التحكم',        icon: ChartPie },
  { to: '/tasks',       label: 'المهام',             icon: ListChecks },
  { to: '/kpi/agents',  label: 'أداء الموظفين',       icon: Trophy },
  { to: '/templates',   label: 'قوالب الرسائل',       icon: ChatCircleText },
  { to: '/letters',     label: 'الخطابات والإشعارات', icon: Scroll },
  { to: '/digest',      label: 'التذكيرات اليومية',   icon: EnvelopeSimple },
  { to: '/reports',     label: 'التقارير',           icon: ChartBar },
  { to: '/users',       label: 'المستخدمين',         icon: ShieldCheck, adminOnly: true },
  { to: '/columns',     label: 'إدارة الأعمدة',       icon: Columns,     adminOnly: true },
  { to: '/backups',     label: 'النسخ الاحتياطية',    icon: Database,   adminOnly: true },
  { to: '/audit',       label: 'سجل العمليات',       icon: ClockCounterClockwise, adminOnly: true },
];

export const LEGAL_NAV = [
  { to: '/legal',           label: 'لوحة القانونية', icon: ChartPie, end: true },
  { to: '/legal/claims',    label: 'المطالبات',       icon: Scales },
  { to: '/legal/cases',     label: 'متابعة القضايا',  icon: Gavel },
  { to: '/legal/settings',  label: 'إعدادات القسم',   icon: ShieldCheck, adminOnly: true },
  { to: '/legal/audit',     label: 'سجل العمليات',    icon: ClockCounterClockwise, adminOnly: true },
];

export const DEPT_BRAND = {
  collections: { label: 'إدارة التحصيل',    en: 'Collection Management', color: '#B4935A', Icon: Coins },
  legal:       { label: 'الإدارة القانونية', en: 'Legal & Judicial',      color: '#1E3A5F', Icon: Scales },
};
